import React from 'react';
import { Card } from "react-bootstrap";
import face_balazs_pejo from "../../assets/img/face_balazs_pejo.jpg";
import ShowMoreText from "react-show-more-text";
import proj_privacy_in_federated_learning from "../../assets/img/proj_privacy_in_federated_learning.png";

const Balazs_Pejo_privacy_federated = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_privacy_in_federated_learning} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_balazs_pejo}
              /* this will be the text on the banner */
              alt="Contribution Evaluation & Privacy in Federated Learning"
            />{" "}
            <p className="text7">Balázs Pejó</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            <p className="text8">CrySysLab, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            In federated learning, there is an inherent tension between privacy and security: strong privacy protections, 
            such as secure aggregation or differential privacy, can make it harder to detect malicious behavior and enforce 
            security guarantees. Contribution evaluation adds another layer of complexity, as its outputs are not simple 
            binary decisions but nuanced, continuous scores that are sensitive to both privacy-preserving techniques and 
            robustness mechanisms. These methods can shift or distort scores even in benign cases, highlighting the need 
            for a unified framework that balances privacy, security, and the fidelity of contribution measurement.
            <br />
            <br />

            Related literature:{" "}

            <ul>
                <li>
                Zhang, Yifei, et al. "A survey of trustworthy federated learning with perspectives on security, robustness and privacy." Companion proceedings of the ACM web conference (2023).
                </li>
                <li>
                Sim, Rachael Hwee Ling, et al. "Data Valuation in Machine Learning: “Ingredients”, Strategies, and Open Challenges." IJCAI (2022).
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balazs_Pejo_privacy_federated;